module.exports = __webpack_public_path__ + "img/6.594793f.png";